<template>
  <div class="page_bg">
    <!-- 顶部返回 -->
    <div class="back_top_name flex-r-sb-c" style=" padding: 0.32rem;background: #ffffff;font-size: 0.48rem;">
      <van-icon name="arrow-left" @click="backPath" />
      <div class="top_name">退款/售后</div>
      <div class="top_icon" />
    </div>
    <!-- list -->
    <div class="order_list_box">
      <MyscrollList ref="myList01" :loading="listLoading" :list="orderList" :line="1" :line-type="1"
                    @myload="orderload"
      >
        <template #default="slotProps">
          <div :id="'order_'+slotProps.index" class="order_list_item" @click="toDetail(slotProps)">
            <!-- 订单单号和状态 -->
            <div class="item_title flex-r-sb-c">
              <div class="item_title_id">订单号：{{ slotProps.item.orderNo }}
                <van-image v-if="slotProps.item.specialPriceFlag" width="1.76rem" height="0.48rem"
                           style="margin-top: 0.2rem;"
                           src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/VIP/special_offer.png"
                />
              </div>
              <div class="item_title_status">{{ statusList[slotProps.item.orderStatus] }}</div>
            </div>
            <div class="flex-r-sb-c">
              <div v-if="slotProps.item.productList.length === 1" class="item_left_pro flex-r-s-c">
                <div class="left_pro_img">
                  <van-image width="1.92rem" height="1.44rem" :src="slotProps.item.productList[0].iconUrl" />
                </div>
                <div class="left_pro_info">
                  <div class="pro_info_name van-multi-ellipsis--l2">{{ slotProps.item.productList[0].name }}</div>
                  <div class="pro_info_msg van-ellipsis">{{ slotProps.item.productList[0].brand }} |
                    {{ slotProps.item.productList[0].specifications }}</div>
                </div>
              </div>
              <div v-else class="item_left_pro">
                <div class="left_pro_img flex-r-c-c ">
                  <van-image v-for="(img,img_index) in slotProps.item.productList" :key="img_index" width="1.92rem"
                             height="1.44rem" :src="img.iconUrl"
                  />
                </div>
              </div>
              <!-- 订单价格和数量 -->
              <div class="item_right_info">
                <div class="right_info_money">￥{{ slotProps.item.orderPrice }}</div>
                <div class="right_info_num">共计{{ slotProps.item.productTypeNum }}件</div>
              </div>
            </div>
          </div>
        </template>
      </MyscrollList>
    </div>
  </div>
</template>

<script>
import './index.scss'
import MyscrollList from '@/components/MyscrollList'
import { mallOrder_buyer_refundList } from '@/api/order'
import { orderPayStatus } from '@/utils/constants'
export default {
  name: 'OrderList',
  components: { MyscrollList },
  data() {
    return {
      // 商品列表
      orderSearch: { page: 1, limit: 10 },
      orderList: [],
      listLoading: false,
      statusList: orderPayStatus.statusList
    }
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      window.sessionStorage.setItem('lasterRouter', from.path)
    })
  },
  created() {
    this.orderSearch.page = 1
    console.log('this.active1', this.active)
    this.getOrderList()
  },
  activated() {
    if (sessionStorage.getItem('order_list_live') === 'true') {
      this.orderSearch.page = 1
      this.orderList = []
      this.getOrderList()
      sessionStorage.setItem('order_list_live', 'false')
    } else {
      var id = sessionStorage.getItem('order_list_id')
      document.getElementById(id).scrollIntoView()
    }
  },
  deactivated() {
    console.log('keepalive 离开')
  },
  methods: {
    backPath() { this.$router.replace('/user/my') },
    getOrderList() {
      this.$toast.loading({ message: '加载中...', forbidClick: true, loadingType: 'spinner', duration: 0 })
      mallOrder_buyer_refundList(this.orderSearch).then(res => {
        this.$toast.clear()
        this.$refs.myList01.load_loading(false)
        this.orderList = this.orderList.concat(res.data.list)
        if (parseInt(res.data.total) === 0) { this.$refs.myList01.load_empty('list', true) } else {
          if (res.data.list.length === 0) { this.$refs.myList01.load_finished(true) } // 数据全部加载完成
        }
      })
    },
    orderload() {
      this.$refs.myList01.load_loading(true)
      this.$utils.debounce(() => {
        this.orderSearch.page = this.orderSearch.page + 1
        this.getOrderList()
        // 加载状态结束
      }, 50)()
    },
    toDetail(slotProps) {
      var id = 'order_' + slotProps.index
      sessionStorage.setItem('order_list_id', id)
      this.$router.push('/order/orderDetail?id=' + slotProps.item.orderId)
    },
    changeTabs(type) {
      this.showTabs = false
      this.orderSearch.page = 1
      this.orderList = []
      this.getOrderList()
    }
  }
}
</script>

<style>
</style>
